import axios from 'axios';

const apiKey = 'be5df98c14msh942da60fb765353p14b542jsn644797c8ac7b';

// * This can be used as the quote that wil be displayed when the website opens for the first time.

export const fetchQuote = async () => {
	const options = {
		method: 'GET',
		url: 'https://quotes-inspirational-quotes-motivational-quotes.p.rapidapi.com/quote',
		headers: {
			'x-rapidapi-key': apiKey,
			'x-rapidapi-host':
				'quotes-inspirational-quotes-motivational-quotes.p.rapidapi.com',
		},
	};
	try {
		const response = await axios.request(options);
		return response.data;
	} catch (error) {
		console.error(error);
	}
};
